<script lang="ts" setup>
import PayPageDefault from './components/PayPage.default.vue'
import PayPageFicmoon from './components/PayPage.ficmoon.vue'
import PayPageNovelarc from './components/PayPage.novelarc.vue'
import PayPageNovelyn from './components/PayPage.novelyn.vue'
import PayPageFlipnovel from './components/PayPage.flipnovel.vue'
import PayPageStorlyn from './components/PayPage.storlyn.vue'
import PayPageNovelmello from './components/PayPage.novelmello.vue'
import { getPayPageConfig } from '@/composables/payment'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置
const config = getPayPageConfig()

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const PayPage = loadBrandComponent({
  rocnovel: PayPageDefault,
  oceread: PayPageDefault,
  ficmoon: PayPageFicmoon,
  novelarc: PayPageNovelarc,
  storyella: PayPageNovelarc,
  aurenovel: PayPageNovelarc,
  florastory: PayPageNovelarc,
  silktale: PayPageNovelarc,
  pearla: PayPageNovelarc,
  fictora: PayPageFicmoon,
  marinovel: PayPageDefault,
  flipnovel: PayPageFlipnovel,
  storlyn: PayPageStorlyn,
  novaris: PayPageStorlyn,
  novelyn: PayPageNovelyn,
  novelmello: PayPageNovelmello,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <PayPage :config="config" />
  </div>
</template>
